<template>
    <div>
        <v-form @submit.prevent="submitCheckinCheckoutForm" :disabled="loading">
            <v-progress-circular
                v-if="loading"
                :size="120"
                color="blue-lighten-3"
                class="loading-spinner"
                indeterminate
                >Loading
            </v-progress-circular>

            <v-row v-if="errors['400']">
                <v-col>
                    <v-alert type="error">{{ errors["400"] }}</v-alert>
                </v-col>
            </v-row>

            <v-row style="display: flex; justify-content: space-between;">
                <v-col>
                    <div class="text-h6">Checkin / Checkout</div>
                </v-col>

                <div style="font-weight: 700;">Old Quantity: {{ material.in_stock }}</div>
            </v-row>

            <v-row style="
                display: flex;
                justify-content: center;
            ">
                <div
                    style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    "
                >
                    <div style="height: auto">
                        <v-icon
                            style="cursor: pointer"
                            :icon="
                                form.type === 'checkin'
                                    ? 'mdi:mdi-clipboard-arrow-down-outline'
                                    : 'mdi:mdi-clipboard-arrow-up-outline'
                            "
                            color="primary"
                        ></v-icon>
                        <v-tooltip activator="parent" location="bottom">
                            <div style="display: flex; flex-direction: column">
                                <div>
                                    <span style="font-size: 16px"
                                        >Checkin:</span
                                    >
                                    <span style="font-style: italic"
                                        >Add to the material's quantity</span
                                    >
                                </div>
                                <div>
                                    <span style="font-size: 16px"
                                        >Checkout:</span
                                    >
                                    <span style="font-style: italic"
                                        >Remove from the material's
                                        quantity</span
                                    >
                                </div>
                            </div>
                        </v-tooltip>
                    </div>
                </div>

                <v-col cols="5">
                    <v-select
                        :error-messages="errors['type']"
                        :items="selects.types"
                        item-title="title"
                        item-value="value"
                        v-model="form.type"
                        variant="underlined"
                        color="primary"
                        label="Movement Type"
                        @update:modelValue="handleTypeChange"
                        :menu-props="{
                            maxHeight: 350,
                        }"
                    ></v-select>
                </v-col>

                <v-col cols="5">
                    <v-text-field
                        :error-messages="errors['quantity']"
                        :prepend-icon="
                            form.type === 'checkin'
                                ? 'mdi:mdi-plus'
                                : 'mdi:mdi-minus'
                        "
                        type="number"
                        min="0"
                        max="10"
                        step="1"
                        :label="
                            form.type === 'checkin'
                                ? 'Amount to add'
                                : 'Amount to remove'
                        "
                        v-model="form.quantity"
                        variant="underlined"
                        color="primary"
                        @update:modelValue="handleQuantityChanged"
                    ></v-text-field>
                    <p id="current-stock">{{ selectedLocationStock }}</p>
                </v-col>
            </v-row>

            <v-row style="
                display: flex;
                justify-content: center;
            ">
                <v-col cols="5">
                    <v-text-field
                        :error-messages="errors['user']"
                        :label="form.type === 'checkin'
                            ? 'Checkin User'
                            : 'Checkout User'"
                        v-model="form.user"
                        variant="underlined"
                        color="primary"
                    ></v-text-field>
                </v-col>

                <v-col cols="5" v-if="!form.newLocationBool">
                    <v-select
                        :disabled="location_with_quantity_bool"
                        :error-messages="errors['location']"
                        :items="selects.locations"
                        item-title="title"
                        item-value="id"
                        v-model="form.location"
                        variant="underlined"
                        color="primary"
                        @update:modelValue="locationChanged"
                        :label="form.type === 'checkin'
                            ? 'Checkin To Location'
                            : 'Checkout From Location'"
                        :menu-props="{
                            maxHeight: 350,
                        }"
                    ></v-select>
                    <v-btn 
                        v-if="!location_with_quantity_bool"
                        variant="elevated"
                        prepend-icon="fa-solid fa-plus"
                        color="green"
                        @click="createNewLocation"
                        class="mt-1 mr-1"
                        block
                    >
                        Add Location
                    </v-btn>
                    
                </v-col>

                <v-col cols="5" v-if="form.newLocationBool">
                    <v-text-field
                        id="new-location-name"
                        :error-messages="errors['locationName']"
                        label="New Location Name"
                        v-model="form.locationName"
                        variant="underlined"
                        color="primary"
                    ></v-text-field>
                    <v-btn
                        variant="elevated"
                        color="red"
                        @click="cancelNewLocation"
                        class="mt-1 mr-1"
                        block
                    >
                        Cancel New Location
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-btn color="primary" type="submit" block
                        >{{ form.type === "checkin" ? "Checkin" : "Checkout" }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import { useMaterials } from "../../stores/Design/Materials";
import { mapWritableState } from "pinia";

export default {
    name: "CheckinCheckoutForm",
    props: {
        material: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            errors: [],
            loading: false,
            selectedLocationStock: '',
            isUsingTablet: false,
            location_with_quantity_bool: false,
            in_stock_quantity: 0,
            form: {
                quantity: 1,
                type: "checkout",
                user: this.$page.props.auth.user?.username ?? null,
                location: null,
                locationName: null,
                newLocationBool: false,
                countryCode: '',
            },
            selects: {
                types: [
                    {
                        title: "Checkin",
                        value: "checkin",
                    },
                    {
                        title: "Checkout",
                        value: "checkout",
                    },
                ],
                locations: []
            },
        };
    },
    async mounted() {
        this.form.countryCode = this.selectedCountryCode ?? this.$page.props.auth.user?.countryCodeFK;
        this.fetchLocations();
        this.fetchTabletBool();
    },
    computed: {
        ...mapWritableState(useMaterials, [
            "selectedCountryCode"
        ])
    },
    methods: {
        fetchTabletBool() {
            var userAgent = navigator.userAgent.toLowerCase();
            
            var tabletKeywords = ['ipad', 'android', 'tablet'];
            for (var i = 0; i < tabletKeywords.length; i++) {
                if (userAgent.indexOf(tabletKeywords[i]) !== -1) {
                    this.isUsingTablet = true; // User is accessing from a tablet
                }
            }
            
            this.isUsingTablet = false;
        },
        
        locationChanged() {
            let quantity = 0
            let title;
            let div = document.getElementById('current-stock');
            if (this.form.location) {
                this.existing_rows.forEach(row => {
                    if (row.location_id === this.form.location) {
                       quantity = row.quantity;
                       this.selects.locations.forEach((loc) => {
                            if (loc.id === row.location_id) {
                                title = loc.title;
                            }
                       })
                    }  
                })
                div.innerHTML = `In Stock in <span style="text-decoration: underline;">${title}</span> - <span style="font-weight: 700;">${quantity}</span>`;
            } else {
                div.innerHTML = '';
            }
        },
        handleQuantityChanged() {
            if (this.form.type === 'checkout' && this.location_with_quantity_bool && (this.form.quantity > this.in_stock_quantity)) {
                this.form.quantity = 1;
                this.errors = {
                    quantity: ["Can not checkout larger quantity then what is in stock"],
                };
                
                setTimeout(() => {
                    this.errors = {
                        quantity: [],
                    };
                }, 4000)
            } else {
                this.errors = {
                    quantity: [],
                };
            }
        },
        handleTypeChange() {
            if (!this.location_with_quantity_bool) {
                this.form.type = 'checkin'
                this.errors = {
                    type: ["Can not checkout when no quantity exists"],
                };

                setTimeout(() => {
                    this.errors = {
                        type: [],
                    };
                }, 4000)
            }
        },
        fetchLocations() {
            axios
                .get(
                    route("api.materials.locations", {
                        countryCodeFK: this.form.countryCode,
                        materialId: this.material.id
                    })
                )
                .then((response) => {
                    this.selects.locations = response.data.locations;

                    if (response.data.existing_rows.length > 0) {
                        this.form.location = response.data.existing_rows[0].location_id;
                        this.existing_rows = response.data.existing_rows;
                        this.location_with_quantity_bool = response.data.location_with_quantity_bool;
                        this.in_stock_quantity = response.data.in_stock_quantity;

                        if (this.in_stock_quantity === 0) {
                            this.form.type = 'checkin';
                        }

                        this.locationChanged();
                    } else {
                        this.form.type = 'checkin';
                        this.form.newLocationBool = true;
                    }
                })
                .catch((obj) => {
                    console.log("Err: ", obj);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        createNewLocation() {
            this.form.newLocationBool = true;
            setTimeout(() => {
                let newLocationInput = document.getElementById('new-location-name');
                newLocationInput.focus();
            }, 25)
        },
        cancelNewLocation() {
            this.form.newLocationBool = false;
        },
        submitCheckinCheckoutForm() {
            const validationPassed = this.validateSubmitRequest();
            if (!validationPassed) return;

            axios
                .post(
                    route("api.materials.checkin-checkout", this.material.id),
                    this.form
                )
                .then((response) => {
                    let message = `${this.form.type} created successfully!`;
                    this.$emit("checkin-checkout-form-submit", message);
                })
                .catch((obj) => {
                    if (obj.response.status === 422) {
                        const errors = obj.response.data.errors;
                        Object.keys(errors).forEach((key) => {
                            console.log(errors[key]);
                            this.errors[key] = errors[key];
                        });
                    }
                    if (obj.response.status === 400) {
                        this.errors["400"] = obj.response.data.message;
                    }
                });
        },
        validateSubmitRequest() {
            if (this.form.quantity === 0) {
                this.errors = {
                    quantity: ["Quantity required"],
                };
                return false;
            } else if (!this.form.user) {
                this.errors = {
                    user: ["User required"],
                };
                return false;
            } else if (this.form.newLocationBool && (!this.form.locationName)) {
                this.errors = {
                    locationName: ["Location required"],
                };
                return false;
            } else if (!this.form.newLocationBool && (!this.form.location)) {
                this.errors = {
                    location: ["Location required"],
                };
                return false;
            }

            return true;
        },
    },
};
</script>

<style scoped></style>
